export const VALIDATE_AUTH_EVENT = 'trimble::validate_auth_event';
